import moment from 'moment';
import React from 'react';
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import 'semantic-ui-css/semantic.min.css'
import 'tippy.js/themes/light.css';
import App from './App';
import "./App.css";
import * as serviceWorker from './serviceWorker';
import { supportedLanguages } from './utils/localizationUtils';

/**
 * set default locale options to be shared for all supported locales:
 *   o use 24h time format
 *   o the first day of the week is Monday
 */
supportedLanguages.forEach(locale => {
  moment.updateLocale(locale, {
    longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY HH:mm',
      LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
  });
});
// override the weekdaysShort values for "de" with the ones from "de_ch"
moment.updateLocale("de", {
  weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_')
});

moment.updateLocale("fr", {
  weekdaysShort: 'lu_ma_me_je_ve_sa_di'.split('_')
});

moment.updateLocale("it", {
  weekdaysShort: 'lu_ma_me_gi_ve_sa_do'.split('_')
});

const defaultLang = "de";
moment.updateLocale(defaultLang, {});


ReactDOM.render((
        <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
          <App/>
        </BrowserRouter>
    ), document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
